import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoDownload = loadable(() => import(/* webpackChunkName: "content/photo-download" */ './PhotoDownload'), 'PhotoDownload');
